(function () {
  if (window.ossCreateCartAccessibility) return;
  window.ossCreateCartAccessibility = function (drawer, closeDrawer) {
    if (drawer.__ossAccessibility) return drawer.__ossAccessibility;
    var panel = drawer.querySelector('.oss-ajax-cart__panel');
    var closeButton = panel.querySelector('.oss-ajax-cart__head [data-oss-ajax-cart-close]');
    var active = false, opener = null, remembered = null, recovering = false, movingFocus = false;
    var escapeHandled = false, queued = false;
    var isolated = new Map();
    var observedPeers = new Set();
    var selector = 'a[href], button, input, select, textarea, summary, iframe, [tabindex], [contenteditable="true"]';
    var peerSelector = '#shopify-pc__banner, #shopify-pc__prefs, [data-oss-subscribe], .oss-mobile-menu, .oss-collection-page, [data-oss-global-variant-modal], [data-oss-collection-variant-modal]';

    function visible(node) {
      if (!node || !node.isConnected || node.closest('[hidden]')) return false;
      var style = getComputedStyle(node);
      return node.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
    }
    function focusable(node) {
      // aria-disabled communicates unavailable actions; unlike disabled, it does not
      // remove a visible link from native Tab order. Keep that order in the trap.
      if (!visible(node) || node.closest('[inert], [aria-hidden="true"]') || node.matches(':disabled') || node.tabIndex < 0) return false;
      var parent = node.parentElement;
      while (parent && parent !== document.body) {
        if (parent.tagName === 'DETAILS' && !parent.open) {
          var summary = parent.querySelector(':scope > summary');
          if (!summary || !summary.contains(node)) return false;
        }
        parent = parent.parentElement;
      }
      return true;
    }
    function nodes(root) {
      // A fresh, unique collection in current DOM order, including after cart renders.
      return Array.from(new Set(root.querySelectorAll(selector))).filter(focusable);
    }
    function focus(node, preventScroll) {
      if (!node) return;
      movingFocus = true;
      node.focus({ preventScroll: preventScroll !== false });
      movingFocus = false;
    }
    function remember(node) {
      var row = node.closest('[data-oss-ajax-cart-key]');
      var controls = ['data-oss-ajax-cart-minus', 'data-oss-ajax-cart-qty', 'data-oss-ajax-cart-plus', 'data-oss-ajax-cart-remove'];
      remembered = { node: node, key: row && row.getAttribute('data-oss-ajax-cart-key'),
        index: row ? Array.from(panel.querySelectorAll('[data-oss-ajax-cart-key]')).indexOf(row) : -1,
        control: controls.find(function (name) { return node.hasAttribute(name); }) };
      recovering = false;
    }
    function releaseBackground() {
      isolated.forEach(function (value, node) {
        if (value === null) node.removeAttribute('inert');
        else node.setAttribute('inert', value);
      });
      isolated.clear();
    }
    function isolateBackground() {
      Array.from(document.body.children).forEach(function (node) {
        if (node === drawer || node.matches('script, style, link, meta, #shopify-pc__banner, #shopify-pc__prefs') || isolated.has(node)) return;
        isolated.set(node, node.getAttribute('inert'));
        node.inert = true;
      });
    }
    function cookieOverlay() {
      return Array.from(document.querySelectorAll('#shopify-pc__prefs, #shopify-pc__banner')).find(function (node) {
        return visible(node) && node.getAttribute('aria-hidden') !== 'true';
      });
    }
    function priorityOverlay() {
      // Consent keeps its own behavior. Yield the cart instead of hiding or trapping the banner.
      return cookieOverlay() || document.querySelector('[data-oss-subscribe][aria-hidden="false"], .oss-mobile-menu[open], .oss-collection-page.is-filter-open .oss-collection-sidebar, [data-oss-global-variant-modal].is-open, [data-oss-collection-variant-modal].is-open');
    }
    function yieldToOverlay(overlay) {
      closeDrawer({ returnFocus: false });
      if (!overlay.contains(document.activeElement)) focus(nodes(overlay)[0]);
    }
    function repairFocus() {
      var current = document.activeElement;
      if (!recovering && panel.contains(current) && focusable(current)) return;
      if (remembered && remembered.key) {
        var rows = Array.from(panel.querySelectorAll('[data-oss-ajax-cart-key]'));
        var same = rows.find(function (row) { return row.getAttribute('data-oss-ajax-cart-key') === remembered.key; });
        var target = same && remembered.control && same.querySelector('[' + remembered.control + ']');
        if (!target || !focusable(target)) {
          var neighbor = rows[Math.min(remembered.index, rows.length - 1)];
          target = neighbor && nodes(neighbor)[0];
        }
        if (target && focusable(target)) {
          focus(target); remember(target); return;
        }
        recovering = rows.length > 0;
      }
      focus(focusable(closeButton) ? closeButton : nodes(panel)[0]);
    }
    var observer = new MutationObserver(schedule);
    function observePeers() {
      document.querySelectorAll(peerSelector).forEach(function (node) {
        if (observedPeers.has(node)) return;
        observedPeers.add(node);
        observer.observe(node, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
          childList: node.matches('#shopify-pc__banner, #shopify-pc__prefs'), subtree: node.matches('#shopify-pc__banner, #shopify-pc__prefs') });
      });
    }
    function sync() {
      queued = false;
      if (!active) return;
      if (!drawer.classList.contains('is-open')) { api.close(); return; }
      var overlay = priorityOverlay();
      if (overlay) { yieldToOverlay(overlay); return; }
      observePeers();
      isolateBackground();
      repairFocus();
    }
    function schedule() {
      if (!active || queued) return;
      queued = true;
      queueMicrotask(sync);
    }
    document.addEventListener('focusin', function (event) {
      if (!active || movingFocus) return;
      var overlay = priorityOverlay();
      if (overlay) { yieldToOverlay(overlay); return; }
      if (panel.contains(event.target)) remember(event.target);
      else focus(closeButton);
    }, true);
    document.addEventListener('keydown', function (event) {
      if (!active) return;
      var overlay = priorityOverlay();
      if (overlay) { yieldToOverlay(overlay); return; }
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopImmediatePropagation();
        escapeHandled = true;
        closeDrawer();
      } else if (event.key === 'Tab') {
        var available = nodes(panel);
        var current = document.activeElement;
        var index = available.indexOf(current);
        event.preventDefault();
        if (index === -1) {
          focus(available.includes(closeButton) ? closeButton : available[0], false);
        } else {
          // Skip state-hidden nodes even when their markup would still allow native Tab.
          focus(available[(index + (event.shiftKey ? -1 : 1) + available.length) % available.length], false);
        }
      }
    }, true);
    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape' || !escapeHandled) return;
      escapeHandled = false;
      event.preventDefault(); event.stopImmediatePropagation();
    }, true);
    // Cookie transitions can finish without another attribute mutation.
    document.addEventListener('transitionend', function (event) {
      if (event.target.closest && event.target.closest('#shopify-pc__banner, #shopify-pc__prefs')) schedule();
    });
    document.addEventListener('visitorConsentCollected', schedule);
    var api = {
      prepareOpen: function (trigger) {
        if (active) return true;
        // Do not run competing-overlay/scroll cleanup against an existing consent dialog.
        var cookie = cookieOverlay();
        if (cookie) { focus(nodes(cookie)[0]); return false; }
        var current = document.activeElement;
        opener = current && current.matches('[data-oss-purchase-submit]') ? current : trigger || current;
        return true;
      },
      open: function () {
        if (active) return;
        active = true;
        drawer.inert = false;
        var overlay = priorityOverlay();
        if (overlay) { yieldToOverlay(overlay); return; }
        focus(closeButton); remember(closeButton);
        isolateBackground();
        observer.observe(document.body, { childList: true, attributes: true, attributeFilter: ['class'] });
        observer.observe(drawer, { childList: true, subtree: true, attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'aria-hidden', 'hidden', 'inert', 'tabindex', 'class', 'style'] });
        observePeers();
      },
      close: function (options) {
        if (!active) return;
        active = false;
        observer.disconnect(); observedPeers.clear();
        releaseBackground();
        if (!options || options.returnFocus !== false) {
          var source = opener;
          var target = opener && focusable(opener) ? opener : Array.from(document.querySelectorAll('.oss-cart-action, .oss-product-form .oss-atc')).find(focusable);
          focus(target);
          // The existing Sticky render runs after body-state restoration. Do not steal focus
          // from a new modal or user action while allowing that source to become visible.
          if (source && source.matches('[data-oss-purchase-submit]')) {
            requestAnimationFrame(function () { requestAnimationFrame(function () {
              if (!active && !priorityOverlay() && document.activeElement === target && focusable(source)) focus(source);
            }); });
          }
        }
        drawer.inert = true;
        remembered = null; recovering = false; opener = null;
      }
    };
    drawer.inert = true;
    drawer.__ossAccessibility = api;
    return api;
  };
})();
